module.exports = __webpack_public_path__ + "static/img/14.6849651.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/sp/14.png
// module id = HE0+
// module chunks = 0